var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_383_5651",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.749023,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_383_5651)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 9.74902V7.74902H21V9.74902H7ZM7 13.749V11.749H21V13.749H7ZM7 17.749V15.749H21V17.749H7ZM4 9.74902C3.71667 9.74902 3.47917 9.65319 3.2875 9.46152C3.09583 9.26986 3 9.03236 3 8.74902C3 8.46569 3.09583 8.22819 3.2875 8.03652C3.47917 7.84486 3.71667 7.74902 4 7.74902C4.28333 7.74902 4.52083 7.84486 4.7125 8.03652C4.90417 8.22819 5 8.46569 5 8.74902C5 9.03236 4.90417 9.26986 4.7125 9.46152C4.52083 9.65319 4.28333 9.74902 4 9.74902ZM4 13.749C3.71667 13.749 3.47917 13.6532 3.2875 13.4615C3.09583 13.2699 3 13.0324 3 12.749C3 12.4657 3.09583 12.2282 3.2875 12.0365C3.47917 11.8449 3.71667 11.749 4 11.749C4.28333 11.749 4.52083 11.8449 4.7125 12.0365C4.90417 12.2282 5 12.4657 5 12.749C5 13.0324 4.90417 13.2699 4.7125 13.4615C4.52083 13.6532 4.28333 13.749 4 13.749ZM4 17.749C3.71667 17.749 3.47917 17.6532 3.2875 17.4615C3.09583 17.2699 3 17.0324 3 16.749C3 16.4657 3.09583 16.2282 3.2875 16.0365C3.47917 15.8449 3.71667 15.749 4 15.749C4.28333 15.749 4.52083 15.8449 4.7125 16.0365C4.90417 16.2282 5 16.4657 5 16.749C5 17.0324 4.90417 17.2699 4.7125 17.4615C4.52083 17.6532 4.28333 17.749 4 17.749Z",
    fill: "#4E4E4E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.e266d7bb8170b060d367c887d98193ed.svg";
export { ForwardRef as ReactComponent };